import React, { FC } from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Request } from "@/types/request";
import { EditRequestForm } from "@/components/pages/requests/EditRequestForm";
import { useUpdateRequest } from "@/components/pages/requests/hooks/useRequests";
import { ModalProps } from "@/types/props/modal-props";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";

interface CreateRequestModalProps extends ModalProps {
  selectedRequest?: Request | null;
  setSelectedRequest: (req: Request | null) => void;
}

const EditRequestModal: FC<CreateRequestModalProps> = ({
  isModalOpen,
  setIsModalOpen,
  selectedRequest,
  setSelectedRequest,
}) => {
  const { t } = useTranslation();
  const updateRequestMutation = useUpdateRequest();

  const handleEditRequest = async (
    id: string,
    updatedRequest: Partial<Request>,
  ) => {
    try {
      await updateRequestMutation.mutateAsync({
        id: id,
        data: updatedRequest,
      });

      toast.success(t("requests.form.requestUpdatedSuccessfully"));
      setIsModalOpen(false);
      setSelectedRequest(null);
    } catch (error) {
      console.error(t("requests.form.failedToUpdateRequest"), error);
    }
  };

  return (
    <Dialog open={isModalOpen} onOpenChange={setIsModalOpen}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t("requests.form.editRequest")}</DialogTitle>
        </DialogHeader>
        {isModalOpen && selectedRequest ? (
          <EditRequestForm
            request={selectedRequest}
            onClose={() => setIsModalOpen(false)}
            onSuccess={handleEditRequest}
          />
        ) : null}
      </DialogContent>
    </Dialog>
  );
};

export default EditRequestModal;
